import { RemoteGetInternshipLocationById } from 'data/usecases';
import { makeApiUrlInternshipLocations } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteGetInternshipLocationById =
  (): RemoteGetInternshipLocationById => {
    return new RemoteGetInternshipLocationById(
      makeApiUrlInternshipLocations(),
      makeAxiosHttpClient(),
    );
  };
